import React from "react"
import _map from 'lodash/map'
import { Spin } from 'antd'
import MailListItem from "./MailListItem"
import CustomScrollbars from 'utils/CustomScrollbars'

const MailList = ({ mails, onMailSelect, onLoadMore, hasMore, loadingMore }) => {
  const handleScrollUpdate = (values) => {
    if (!values) return
    const isNearBottom =
      values.top >= 0.8 ||
      (values.scrollHeight > values.clientHeight &&
        values.scrollHeight - (values.scrollTop + values.clientHeight) < 150)

    if (isNearBottom && hasMore && !loadingMore && onLoadMore) {
      onLoadMore()
    }
  }

  return (
    <div className="gx-module-list gx-mail-list">
      <CustomScrollbars className="gx-module-content-scroll" onUpdate={handleScrollUpdate}>
        {
          _map(mails, (mail, index) =>
            <MailListItem
              key={mail.messageUid || index}
              mail={mail}
              onMailSelect={onMailSelect}
            />
          )
        }
        {loadingMore && (
          <div className="gx-text-center gx-p-3" style={{ padding: '16px 0', width: '100%' }}>
            <Spin size="small" /> <span className="gx-ml-2" style={{ color: '#8c8c8c' }}>Loading more emails...</span>
          </div>
        )}
        {hasMore && !loadingMore && mails && mails.length >= 10 && (
          <div className="gx-text-center gx-p-2" style={{ padding: '12px 0', width: '100%' }}>
            <span
              onClick={onLoadMore}
              className="gx-link gx-text-primary"
              style={{ cursor: 'pointer', fontSize: '13px' }}
            >
              Load more emails...
            </span>
          </div>
        )}
      </CustomScrollbars>
    </div>
  )
}

export default MailList
